import React from "react";
import { Typography, Card } from "antd";

const { Title, Text } = Typography;

const HeadingChip = (props) => {
  const { heading, value } = props;

  return (
    <Card title={`${heading}  (${value && value})`} bordered={false} style={{ borderRadius: 4 }} 
    extra={<a href="#">More</a>}
    >
      {/* <Title level={4} className="mb-0 ag-primary">
        {heading} {value && <Text>({value})</Text>} 
      </Title> */}
     
    </Card>
  );
};

export default HeadingChip;
